import React from 'react';

export class EditorHeader extends React.Component
{
    render() {
        let style = undefined;
        if (!this.props.isReadOnly) {
            let borderColor = this.props.isNew ? "#24A698" : "#F15A22";
            style = { borderLeft: `4pt solid ${borderColor}`, paddingLeft: '2pt' };
        }

        return <h3 style={style}>{this.props.text}</h3>;
    }
}


// WEBPACK FOOTER //
// ./src/components/EditorHeader.js